const initialState = {
    loginRedirectDetails: {}
}
const loginRedirectReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SETLOGINREDIRECTDETAILS":
            console.log(action.payload, "action.payload");
            return {
                ...state,
                loginRedirectDetails: action.payload
            };

        default:
            return { ...state };

    }
}
export default loginRedirectReducer